// ═══════════════════════════════════════════════════════════════
// MÓDULO TSS - PLANILLAS DE SEGURIDAD SOCIAL
// ═══════════════════════════════════════════════════════════════

import React, { useState } from 'react';
import { FileText, History, Shield, Settings } from 'lucide-react';
import PlanillaGenerator from './components/PlanillaGenerator';
import PlanillaHistorial from './components/PlanillaHistorial';
import FormatosConfig    from './components/FormatosConfig';

const TABS = [
  { id: 'generar',   label: 'Generar Planilla', icon: FileText  },
  { id: 'historial', label: 'Historial',         icon: History   },
  { id: 'formatos',  label: 'Formatos',          icon: Settings  },
];

export default function TSSModule({ currentCompany }) {
  const [tab, setTab] = useState('generar');

  if (!currentCompany?.id) {
    return (
      <div className="flex flex-col items-center justify-center py-20 text-gray-400">
        <Shield className="w-10 h-10 mb-3" />
        <p className="text-sm">Selecciona una empresa para continuar</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {/* Header */}
      <div className="bg-gradient-to-r from-blue-800 to-blue-900 rounded-xl p-5 text-white">
        <div className="flex items-center gap-3">
          <Shield className="w-7 h-7" />
          <div>
            <h2 className="text-xl font-bold">Planillas TSS</h2>
            <p className="text-blue-200 text-sm">Tesorería de la Seguridad Social — Motor configurable</p>
          </div>
        </div>
      </div>

      {/* Tabs */}
      <div className="flex gap-1 bg-gray-100 p-1 rounded-lg w-fit">
        {TABS.map(t => {
          const Icon = t.icon;
          return (
            <button
              key={t.id}
              onClick={() => setTab(t.id)}
              className={`flex items-center gap-2 px-4 py-2 rounded-md text-sm font-medium transition-colors ${
                tab === t.id
                  ? 'bg-white text-blue-700 shadow-sm'
                  : 'text-gray-600 hover:text-gray-800'
              }`}
            >
              <Icon size={15} />
              {t.label}
            </button>
          );
        })}
      </div>

      {/* Content */}
      {tab === 'generar'   && <PlanillaGenerator companyId={currentCompany.id} />}
      {tab === 'historial' && <PlanillaHistorial companyId={currentCompany.id} />}
      {tab === 'formatos'  && <FormatosConfig    companyId={currentCompany.id} />}
    </div>
  );
}
